import { createContext } from 'react';
import { ReviewApprovalContextValue } from '../../types';

export const ReviewApprovalContext = createContext<ReviewApprovalContextValue | null>(null);
